import { render, staticRenderFns } from "./SnsLogoList.vue?vue&type=template&id=58562bc3&"
import script from "./SnsLogoList.vue?vue&type=script&lang=js&"
export * from "./SnsLogoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports